import html2canvas from 'html2canvas';
export default function (el = 'printArea', title = '打印面辅料', cssFile, rootCls) {
	let timer;
	const content = document.querySelector(el).innerHTML;
	const newWindow = window.open(title, '_blank');
	const head = `<html><head><link href="/static/resources/${cssFile}.css" rel="stylesheet" type="text/css">`
	const preBody = `<body class="${rootCls}">`;
	const nxtBody = `</body></html>`;

	const ctx = head + preBody + content + nxtBody;

	newWindow.document.write(ctx);

	// 监听页面重新渲染后再打印
	// 拿最后一次resize结果
	newWindow.onresize = function () {
		clearTimeout(timer);
		timer = setTimeout(() => {
			newWindow.print();
			// newWindow.close();
		}, 500)
	}
	newWindow.onafterprint = (event) => {
		// alert('执行了')
		console.log('After print');
		newWindow.onresize = null
		clearTimeout(timer);
	};
}

export function createIframePrint(el, options = { useCORS: true, logging: true, scale: 1, dpi: 1080, }, isFull = true) {
	return html2canvas(el, options)
		.then(canvas => {
			return createFrame(canvas.toDataURL("image/png"), el, isFull)
		})
}

function createFrame(src, el, isFull = true) {
	const elWidth = isFull ? '100%' : el.offsetWidth + 'px';
	const availWidth = window.screen.availWidth;
	// const width = el.offsetWidth;
	let iframe = document.getElementById("print-iframe");
	return new Promise((resolve, reject) => {
		if (!iframe) {
			iframe = document.createElement('IFRAME');
			var doc = null;
			iframe.setAttribute("id", "print-iframe");
			iframe.setAttribute('style', `position:absolute;width:${availWidth}px;height:auto;left:-9999px;top:-9999px;`);
			document.body.appendChild(iframe);
			doc = iframe.contentWindow.document;
			//这里可以自定义样式
			const img = new Image();
			img.addEventListener('load', () => {
				iframe.contentWindow.focus();
				iframe.contentWindow.print();
				document.body.removeChild(iframe);
			})
			img.style = `width: ${elWidth}; height:auto;`
			const meta1 = '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">';
			const meta2 = '<meta content="width=device-width, initial-scale=1" name="viewport">';
			const meta3 = '<meta name="viewport" content="width=device-width, minimum-scale=1">';
			const style = `<style type="text/css">*{padding:0;margin:0;box-sizing: border-box;}body,html{height:auto;}</style>  `
			doc.getElementsByTagName('head')[0].innerHTML = meta1 + meta2 + meta3 + style;
			img.src = src;
			doc.getElementsByTagName('body')[0].append(img)
			doc.close();
			resolve()
		}
		else {
			resolve()
		}
	})
}


export function toHiPrint(tmp, data) {
	hiprint.init();
	var hiprintTemplate = new hiprint.PrintTemplate({
		template: tmp,
		settingContainer: '#printBox'
	});
	hiprintTemplate.print(data)
}